import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BrowserCacheLocation, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';
import { Brand } from '../../common/brand-config';

 
export function msalInstanceFactory(type: Brand) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const configs = environment.msal as any;
  const config = configs[type] || configs['Scania'];
  if (!config) {
    throw new Error(`MSAL configuration not found for brand: ${String(type)}`);
  }
  return new PublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      redirectUri: environment.redirectUrl,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
  });
}
 
@Injectable({
  providedIn: 'root'
})
export class DynamicMsalService {
  constructor(private msalService: MsalService) { }
 
  async login(scopes: string[] = [`User.Read`]) {
    // eslint-disable-next-line no-useless-catch
    try {
      await this.msalService.instance.initialize();
      const loginResponse = this.msalService.loginPopup({ scopes }).toPromise();
      return loginResponse;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
 
  // TODO
  async logout() {
 
    try {
      await this.msalService.logoutPopup();
    } catch (error) {
      console.log('Logout failed', error);
      throw error;
    }
  }
}
 